import { Options } from '@sheerid/jslib';
import { RecursivePartial } from './lib/types/types';

export const programId = '61255771ba61df1ff5c65851';

export const defaultOptions: RecursivePartial<Options> = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com/',
    },
    logLevel: 'error',
    useFingerprinting: true,
    marketConsent: {
        enabled: true,
        required: true,
    },
    urlEmploymentFaq: 'https://offers.sheerid.com/sheerid/help-center/',
};
